import type { Role } from '@cf/shared';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router';

import { useAuth } from '../lib/auth';

/** Guards a route subtree. OWNER passes every role check (mirrors the API RolesGuard). */
export function RequireAuth({ roles, children }: { roles?: readonly Role[]; children: ReactNode }) {
  const { user, restoring } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (restoring) {
    return (
      <div className="grid min-h-screen place-items-center text-stone-500">
        {t('common.loading')}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (roles && user.role !== 'OWNER' && !roles.includes(user.role))
    return <Navigate to={homeFor(user.role)} replace />;
  return <>{children}</>;
}

/** Landing route per role; the owner lands on the mobile dashboard on small screens. */
export function homeFor(role: Role): string {
  if (role === 'OPERATOR') return '/operator';
  if (role === 'OWNER' && window.matchMedia('(max-width: 767px)').matches) return '/owner';
  return '/';
}
